import React, { Component } from 'react';

import LoadMore from 'common/common/LoadMore';
import Spinner from 'common/Spinner';

import Notification from './Notification';

import type { NotificationsState } from 'common/reducers/notifications';

import 'css/components/_NotificationList.scss';

type Props = {
  notifications: NotificationsState;
  onLoadMoreTapped: () => void;
};

export default class NotificationList extends Component<Props> {
  // LoadMore is not TS so we have to use any
  private loadMoreRef = React.createRef<any>();

  // this is accessed by the parent component via a ref
  onScroll = (scrollContainer: HTMLDivElement) => {
    // passing null as the first arg since LoadMore.onScroll does not actually use the event
    this.loadMoreRef.current?.onScroll(null, scrollContainer);
  };

  renderLoadMore(notifications: NonNullable<NotificationsState>) {
    const { hasNextPage, loadingMore } = notifications;

    return (
      <div className="loadMoreContainer">
        <LoadMore
          hasMore={hasNextPage}
          loadingMore={loadingMore}
          onLoadMore={this.props.onLoadMoreTapped}
          ref={this.loadMoreRef}
        />
      </div>
    );
  }

  renderList(notifications: NonNullable<NotificationsState>) {
    if (notifications.items.length === 0) {
      return (
        <div className="nullState card">
          <span className="noNotificationsMessage">You have no notifications.</span>
        </div>
      );
    }

    return (
      <div className="notificationListBody card">
        <div className="notifications">
          {notifications.items.map((notification) => (
            <Notification key={notification._id} notification={notification} tint={true} />
          ))}
        </div>
        {this.renderLoadMore(notifications)}
      </div>
    );
  }

  renderContents() {
    const { notifications } = this.props;
    if (!notifications || notifications.loading) {
      return (
        <div className="loading">
          <Spinner />
        </div>
      );
    }

    return this.renderList(notifications);
  }

  render() {
    return <div className="notificationList">{this.renderContents()}</div>;
  }
}
